"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BundlePage = require("./BundlePage");

var _PlanButton = _interopRequireDefault(require("./PlanButton"));

var MarketingPlanButton = function MarketingPlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition,
      setActiveEdition = _ref.setActiveEdition;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      marketingPlanSelected = _useContext.state.marketingPlanSelected;

  return _react.default.createElement(_PlanButton.default, {
    edition: edition,
    merchandiseId: merchandiseId,
    selected: marketingPlanSelected === merchandiseId,
    onSelectedChange: function onSelectedChange() {
      return setActiveEdition(edition);
    }
  });
};

var _default = MarketingPlanButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/MarketingPlanButton.js
// module id = 690
// module chunks = 5 6